export const actionTypes = {
  SHOW_RECOMMENDED_FIELDS_MODAL: 'MODALS/SHOW_RECOMMENDED_FIELDS_MODAL',
  SET_IS_SUBMITTED_RECOMMENDED_FIELDS_MODAL: 'MODALS/SET_IS_SUBMITTED_RECOMMENDED_FIELDS_MODAL',
};
